import { render, staticRenderFns } from "./SAvatar.vue?vue&type=template&id=5eb3492c&scoped=true"
import script from "./SAvatar.vue?vue&type=script&lang=js"
export * from "./SAvatar.vue?vue&type=script&lang=js"
import style0 from "./SAvatar.vue?vue&type=style&index=0&id=5eb3492c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb3492c",
  null
  
)

export default component.exports